import React from 'react';
import { ComponentWithAs, Flex, FlexProps, forwardRef } from '@chakra-ui/react';
import RecommendButton from '../../common/molecule/RecommendButton';
import FindRestaurantButton from '../molecule/FindRestaurantButton';
import { ResultProps } from '../../../type';

const ResultNavigationSection: ComponentWithAs<'div', FlexProps & ResultProps> = forwardRef<
  FlexProps & ResultProps,
  'div'
>((props, ref) => {
  return (
    <Flex width='100%' justify='space-evenly' ref={ref} {...(props as FlexProps)} mb={24}>
      <RecommendButton text='다시 추천받기' size='md' exclude={props.food} mx={1} />
      <FindRestaurantButton {...(props as ResultProps)} variant='secondaryOutline' size='md' mx={1} />
    </Flex>
  );
});

export default ResultNavigationSection;
